var map = {
	"./tips.png": 48009,
	"./tips1.png": 16923,
	"./tips10.png": 73588,
	"./tips11.png": 9331,
	"./tips12.png": 5690,
	"./tips2.png": 48611,
	"./tips3.png": 58558,
	"./tips4.png": 71184,
	"./tips5.png": 71005,
	"./tips6.png": 91918,
	"./tips7.png": 38662,
	"./tips8.png": 92124,
	"./tips9.png": 79541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37347;